import { createContext } from 'react'

export const StatusBarContext = createContext({})
